import styled, { css } from 'styled-components';

import Umbrella from 'ggApp/shared/icons/umbrella';

const Container = styled.div`
    display: flex;
    align-items: center;
`;

const Icon = styled(Umbrella)`
    height: 24px;
    width: 24px;
    margin-right: 16px;
    & > * {
      fill: ${({ theme }) => theme.colors.Foreground};
    }
`;

const TextWrap = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

const Discount = styled.p`
    ${({theme}) => css(theme.typography.Paragraph)};
    display: inline;
    color: green;
    text-transform: uppercase;
`;

const ToolTipText = styled.div`
  ${({theme}) => css(theme.typography.Paragraph)};
  color: ${({ theme }) => theme.colors.Foreground};
    &:before {
        content: " ";
        white-space: pre;
    }
    span {
        text-decoration: underline;
        cursor: help;
    }
`;

export {
    Container,
    Icon,
    TextWrap,
    Discount,
    ToolTipText,
};
